import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { I18nModule } from '../core-frontend-common/template/shared/i18n/i18n.module';

import { UserProfileViewComponent } from './views/user-profile-view/user-profile-view.component';

import { AppCommunicationService } from './services/app-communication.service';
import { DashboardComponent } from './views/dashboard/dashboard.component';
import { CustomPipesModule } from './pipes/customPipes.module';
import { TileComponent } from './components/tile/tile.component';
import { UserSearchComponent } from './components/user-search/user-search.component';
import { ExternalUserModalFormComponent } from './components/external-user-modal-form/external-user-modal-form.component';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { CalendarModule } from 'primeng/calendar';
import { DevComponent } from './components/dev/dev.component';
import { UserPipe } from './pipes/user.pipe';
import { FullCalendarModule } from 'primeng/fullcalendar';
import { TableModule } from 'primeng/table';
import { SharedModule } from '../core-frontend-common/template/shared/shared.module';
import { SmartClockpickerDirective } from '../core-frontend-common/template/shared/utils/smart-clockpicker.directive';
import { BtnGroupFilterComponent } from './components/btn-group-filter/btn-group-filter.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { EpcComponent } from './views/epc/epc.component';
import { EtdComponent } from './views/etd/etd.component';
import { IsbnComponent } from './views/isbn/isbn.component';
import { HelpdeskComponent } from './views/helpdesk/helpdesk.component';
import { RoombookComponent } from './views/roombook/roombook.component';
import { ZpComponent } from './views/zp/zp.component';
import { UikComponent } from './views/uik/uik.component';
import { OthersComponent } from './views/others/others.component';
import { FaqSectionComponent } from './components/etd/faq-section/faq-section.component';
import { NewFaqComponent } from './components/etd/new-faq/new-faq.component';
import { OriginalityComponent } from './views/originality/originality.component';
import { NotificationsViewComponent } from './views/notifications-view/notifications-view.component';
import { NotificationsComponent } from './components/notifications/notifications.component';
import { EtdService } from './services/etd.service';
import { OriginalityService } from './services/originality.service';
import { BaseModalDialogModule } from './components/dialog/base-modal-dialog.module';
import { DeviceDetectorService } from 'ngx-device-detector';
import { FloatNumberFormatDirective } from './directives/floatNumberFormat.directive';
import { FocusDirective } from './directives/focus.directive';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { InputTextModule } from 'primeng/inputtext';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { EditorModule } from 'primeng/editor';
import { ConfirmationService } from 'primeng/api';
import { ErrorReportsViewComponent } from './views/error-reports-view/error-reports-view.component';
import { NotificationModule } from './components/notification/notification.module';
import { EpcProjectsComponent } from './views/epc/sections/epc-projects/epc-projects.component';
import { EpcService } from './services/epc.service';
import { ProjectFormComponent } from './views/epc/components/project-form/project-form.component';
import {
  CheckboxModule,
  ChipsModule,
  DropdownModule,
  MessageService,
  MultiSelectModule,
  RadioButtonModule,
  SelectButtonModule,
} from 'primeng';
import { DiscountSchoolSectionComponent } from './views/originality/originality-sections/discount-school-section/discount-school-section.component';
import { DiscountUserSectionComponent } from './views/originality/originality-sections/discount-user-section/discount-user-section.component';
import { PromocodeSectionComponent } from './views/originality/originality-sections/promocode-section/promocode-section.component';
import { OriginalityOrdersListComponent } from './views/originality/originality-sections/originality-orders-list/originality-orders-list.component';
import { CustomDatepickerModule } from './components/custom-datepicker/custom-datepicker.module';
import { ListPromocodesComponent } from './views/originality/originality-sections/list-promocodes/list-promocodes.component';
import { GeneratePromocodeEmailComponent } from './views/originality/originality-sections/discount-user-section/generate-promocode-email/generate-promocode-email.component';
import { ThesisOrderMail } from './views/originality/components/thesis-order-mail/thesis-order-mail';
import { OriginalitySendMailSectionComponent } from './views/originality/originality-sections/originality-send-mail-section/originality-send-mail-section.component';

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    I18nModule,
    CustomPipesModule,
    RouterModule,
    AutoCompleteModule,
    ModalModule,
    CalendarModule,
    TooltipModule,
    FullCalendarModule,
    TableModule,
    InputTextModule,
    PopoverModule,
    ConfirmDialogModule,
    SharedModule,
    NgMultiSelectDropDownModule.forRoot(),
    BaseModalDialogModule,
    TabsModule,
    EditorModule,
    NotificationModule,
    CheckboxModule,
    CustomDatepickerModule,
    RadioButtonModule,
    DropdownModule,
    MultiSelectModule,
    ChipsModule,
    SelectButtonModule,
  ],
  declarations: [
    DashboardComponent,
    UserProfileViewComponent,
    DashboardComponent,
    TileComponent,
    UserSearchComponent,
    ExternalUserModalFormComponent,
    UserPipe,
    DevComponent,
    SmartClockpickerDirective,
    FloatNumberFormatDirective,
    BtnGroupFilterComponent,
    FocusDirective,
    UserProfileViewComponent,
    DashboardComponent,
    TileComponent,
    UserSearchComponent,
    ExternalUserModalFormComponent,
    DashboardComponent,
    EpcComponent,
    EtdComponent,
    IsbnComponent,
    HelpdeskComponent,
    RoombookComponent,
    ZpComponent,
    UikComponent,
    OthersComponent,
    FaqSectionComponent,
    NewFaqComponent,
    DevComponent,
    OriginalityComponent,
    BtnGroupFilterComponent,
    NotificationsViewComponent,
    NotificationsComponent,
    ErrorReportsViewComponent,
    EpcProjectsComponent,
    ProjectFormComponent,
    DiscountSchoolSectionComponent,
    DiscountUserSectionComponent,
    PromocodeSectionComponent,
    OriginalityOrdersListComponent,
    ListPromocodesComponent,
    GeneratePromocodeEmailComponent,
    ThesisOrderMail,
    OriginalitySendMailSectionComponent,
  ],
  exports: [],
  providers: [
    AppCommunicationService,
    ConfirmationService,
    EtdService,
    OriginalityService,
    DeviceDetectorService,
    EpcService,
    DatePipe,
    MessageService
  ],
})
export class CustomModule {
}
